import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { textStyleCss } from 'src/theme/atlas';
import { FormState } from 'src/types';
import styled from 'styled-components';

export const StyledTextInput = styled.input<{
  state: FormState;
  type: string;
  $removeMarginBottom?: boolean;
}>`
  border-radius: 2px;
  ${(props) => {
    if (props.type !== 'date') {
      return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '7px 16px',
      };
    }

    return {
      padding: '6px 16px',
    };
  }}
  margin-top: 8px;
  margin-bottom: ${({ $removeMarginBottom }) =>
    $removeMarginBottom ? 0 : '8px;'};
  border: 1px solid
    ${(props) => {
      if (props.state === FormState.ERROR)
        return props.theme.atlas.semantic.color.status.error.default;
      if (props.state === FormState.WARNING)
        return props.theme.atlas.semantic.color.status.warning.default;
      if (props.state === FormState.SUCCESS)
        return props.theme.atlas.semantic.color.status.success.default;
      if (props.state === FormState.DISABLED)
        return props.theme.atlas.semantic.color.outline.disabled;
      return props.theme.atlas.semantic.color.outline.default;
    }};
  border-radius: 3px;
  width: 100%;
  background-color: ${(props) =>
    props.state === FormState.READONLY
      ? props.theme.atlas.semantic.color.surface.variant
      : props.theme.atlas.semantic.color.surface.default};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  ${(props) => {
    if (
      props.state === FormState.DISABLED ||
      props.state === FormState.READONLY
    ) {
      return {
        color: props.theme.atlas.semantic.color.type.disabled,
        cursor: 'not-allowed',
      };
    }
  }}

  ${(props) => {
    if (
      props.state === FormState.DISABLED ||
      props.state === FormState.READONLY
    ) {
      return '';
    }
    if (props.theme.isVaultVariant) {
      return [
        ':focus {',
        'border: 1px solid ' + props.theme.newPalette.turquoise.T400 + ';',
        'outline: 3px solid ' + props.theme.newPalette.turquoise.T100 + ';',
        '}',
      ].join('');
    }
    return [
      ':focus {',
      'outline: none;',
      'box-shadow: ' + props.theme.atlas.semantic.shadow.focus + ';',
      '}',
    ].join('');
  }}

  /* clears the 'X' from search input */
  ::-ms-clear {
    display: none;
    width: 0;
    height: 0;
  }
  ::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
  }
  ::-webkit-search-decoration,
  ::-webkit-search-cancel-button,
  ::-webkit-search-results-button,
  ::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }
`;

export const StyledButtonIcon = styled(StyledIcon)<{
  isClickable?: boolean;
  $adjustIconTopMargin?: string;
}>`
  cursor: ${(props) => (props.isClickable ? 'pointer' : 'default')};
  margin-left: -38px;
  margin-top: ${(props) => props.$adjustIconTopMargin ?? 0};
`;

export const TextInputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;
